import wayabankLogo from "../../assets/images/logo.svg";
import React from "react";
import { ComingSoonWrapper } from "./style";
import Layout from "../../components/Layout";
const ComingSoon = () => {
  return (
    <Layout>
      <ComingSoonComponent percentage={35} />
    </Layout>
  );
};
export default ComingSoon;

export const ComingSoonComponent = ({ percentage }) => {
  return (
    <ComingSoonWrapper>
      <div className="body">
        <div id="main">
          <img src={wayabankLogo} alt="Logo Image" />
          <h1>WAYABANK</h1>
          <h2>Coming Soon</h2>
          <div id="progress">
            <div id="fill">
              <div id="barpercent">
                <h4>{percentage}%</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ComingSoonWrapper>
  );
};
